import e, { useRef as n, useCallback as r } from "react";
var t = function t(_t) {
  var c = n(),
    a = r(function (e) {
      !_t.loading && (c.current && c.current.disconnect(), c.current = new IntersectionObserver(function (e) {
        e[0].isIntersecting && _t.canLoadMore && _t.onNextPage();
      }), e && c.current.observe(e));
    }, [_t.loading, _t.canLoadMore, _t.onNextPage]);
  return e.createElement("span", {
    className: "infinite-scroll-tracker",
    ref: a,
    style: {
      display: "inline-block",
      width: "100%",
      height: "".concat(_t.height, "px")
    }
  });
};
export { t as default };